import type { FileWithPath } from 'react-dropzone'

export interface IVideo {
  category: string
  description?: string
  duration?: number
  file_name: string
  mime_type: string
  size: number
  tags?: string[]
  title: string
}

export type IVideoCreate = IVideo

export interface IVideoUpdate {
  category: string
  description?: string
  id: string
  tags: string[]
  title: string
}

export interface IVideoResultItem extends Omit<IVideo, 'tags'> {
  created_at: string
  created_by: string
  download_url: string
  expiration_in: number
  expiration_ts: number
  file_id: string
  id: string
  tags: IVideoTag[]
  thumbnail_url?: string
  title: string
  updated_at: string
  updated_by: string
}

export interface IVideoTag {
  id: string
  name: string
}

export interface IVideoResultCreate extends IVideoResultItem {
  status: string
  upload_url: string
  upload_url_created_at_ts: number
  upload_url_expired_at_ts: number
}

export interface IVideoTagResultItem {
  name: string
}

export interface IFileWithAdditionalData extends FileWithPath {
  preview?: string
}

export enum VIDEO_CATEGORIES {
  CONFERENCES = 'conferences',
  LATEST = 'latest',
  MONTHLY = 'monthly',
  MY_LIST = 'my-list',
  OTHER = 'other',
  PEOPLE = 'people',
  TUTORIALS = 'tutorials',
}

export interface IVideoCategory {
  label: string
  value: VIDEO_CATEGORIES
}
